export type PaidMediaTabId =
  | "overview"
  | "meta-ads-report"
  | "google-ads-report"
  | "tiktok-ads-report"
  | "snapchat-ads-report";

export const PAID_MEDIA_TAB_ITEMS: Array<{ id: PaidMediaTabId; label: string }> = [
  { id: "overview", label: "Paid Media Overview" },
  { id: "meta-ads-report", label: "Meta Ads Report" },
  { id: "google-ads-report", label: "Google Ads Report" },
  { id: "tiktok-ads-report", label: "TikTok Ads Report" },
  { id: "snapchat-ads-report", label: "Snapchat Ads Report" },
];
